// extracted by mini-css-extract-plugin
export default {"wrapper":"uA-z","viewport":"vA-z","container":"wA-z","slide":"xA-z"};